<template>
    <b-modal ref="modal" centered :title="$t('STORETOSTORETRANSFER')" @close="close()" no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="d-block mt-2">
          <div role="group" class="b-form-group form-group" v-if="formValues != null">
            <div v-if="formValues.storeToStoreId == null || formValues.requestingStoreId === globals.storeId">
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('EMPLOYEE')">
                      <inputvalidation :formerror="formError" name="requestUserId">
                        <b-form-select :options="users.root" v-model="formValues.requestUserId" value-field="userId" text-field="name"></b-form-select>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('GUESTNAME')">
                      <inputvalidation :formerror="formError" name="guestName">
                        <b-form-input type="text" v-model="formValues.guestName"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('GUESTPHONE')">
                      <inputvalidation :formerror="formError" name="guestPhone">
                        <b-form-input type="text" v-model="formValues.guestPhone"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('ITEM')">
                      <inputvalidation :formerror="formError" name="item">
                        <b-form-input type="text" v-model="formValues.item"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('STORETRANSFERDESCRIPTION')">
                            <inputvalidation :formerror="formError" name="productDescription">
                                <textarea class="form-control" v-model="formValues.productDescription" rows="3" v-bind:placeholder="$t('DESCRIPTION')"></textarea>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('STORETRANSFERCOLOR')">
                      <inputvalidation :formerror="formError" name="productColor">
                        <b-form-input type="text" v-model="formValues.productColor"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('TRANSFERADDITIONALDATE')">
                      <inputvalidation :formerror="formError" name="tranferAdditionalData">
                        <b-form-select :options="status" v-model="formValues.tranferAdditionalData"></b-form-select>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg" v-if="formValues.sentByUserId != null">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('ISPAID')">
                            <b-form-checkbox :plain="true" v-model="formValues.isPaid" :value="1">{{$t('ISPAID')}}</b-form-checkbox>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('STORE')">
                      <inputvalidation :formerror="formError" name="requestedStoreId">
                        <b-form-select :options="store.root" v-model="formValues.requestedStoreId" value-field="storeId" text-field="name"></b-form-select>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
              </div>
              <div v-if="formValues.requestedStoreId === globals.storeId">
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('TRANSFERID')">
                      <inputvalidation :formerror="formError" name="transferId">
                        <b-form-input type="text" v-model="formValues.transferId"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
                <div class="form-row mb-lg">
                  <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('POSTTRACKING')">
                      <inputvalidation :formerror="formError" name="postTracking">
                        <b-form-input type="text" v-model="formValues.postTracking"></b-form-input>
                      </inputvalidation>
                    </b-form-fieldset>
                  </div>
                </div>
              </div>     
            </div>
          </div>

          <div class="text-right">
              <b-btn variant="secondary-trans mr-4" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn variant="primary" @click="submitData(formValues)">{{$t('SAVE')}}</b-btn>
          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/storetostore/StoreToStoreTransfer.js';
import UserApi from '@/api/salesportal/Store'

export default
{
    name: 'StoreToStoreTransferForm',
    props: ['value', 'store'],
    data()
    {
        const me = this;

        return {
            formError: {},
            formValues: null,
            formData: null,
            users: {},
            status: [
            {
              value: me.$i18n.t('YES'),
              text: me.$i18n.t('YES')
            },
            {
              value: me.$i18n.t('NO'),
              text: me.$i18n.t('NO')
            }],
        };
    },
    methods:
    {
        async getData(storeToStoreId)
        {
          const me = this;
          try 
          {
            me.loading = true;
            const data = await Api.selectRowById({id: storeToStoreId});
            if (data.error && data.error === true)
            {
              throw (data);
            }
            me.formValues = data.root;
          } 
          catch (error) 
          {
            console.log(error);
            me.$notify.notice(error);
          } 
          finally
          {
            me.loading = false;
          }
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.storeToStoreId !== 'undefined')
                {
                    item.id = item.storeToStoreId;
                    delete (item.storeToStoreId);
                }
                
                const data = await Api.submitData(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async getUserData()
      {
        const me = this;
        try
        {

          const params = {};

          if (me.globals.storeId != null && me.formValues.requestUserId == null)
          {
            params.storeId = me.globals.storeId;
            me.$set(me.formValues, 'requestUserId', me.globals.userId);
          }

          const data = await UserApi.selectUsers(params);

          if (data.error && data.error == true)
          {
            me.$notify.notice(data);
            return;
          }

          me.users = data;
        }
        catch (e)
        {
          me.$notify.notice(e);
        }
      },
        close()
        {
            const me = this;
            me.formData = null;
            me.formValues = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                if (val.storeToStoreId != null)
                {
                    await me.getData(val.storeToStoreId);
                }
                else
                {
                    me.formValues = { ...val };
                }
                await me.getUserData();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
                me.formValues = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
